<template>
  <div class="flex h-screen bg-indigo-100">
    <div class="container m-auto">
      <form
        form v-on:submit.prevent="send"
        class="container mx-auto max-w-md rounded-lg overflow-hidden shadow-lg bg-white"
      >
        <div class="px-6 pt-6 pb-6">
          <div class="flex justify-center mb-2">
            <div class="font-medium font-sans text-2xl mb-2 text-gray-800">Create your Convodo account</div>
          </div>

          <!-- First Name -->
          <label
            class="pt-4 block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="first-name">
            First Name
          </label>
          <input
            v-model.trim="$v.formResponses.first_name.$model"
            class="font-sans appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            type="text"
            placeholder="Jane"
            required
          >
          <p v-if="this.invalid">
            <span v-if="!$v.formResponses.first_name.required" class="text-red-500 text-xs italic mt-1 ml-1">Please fill out your first name.</span>
          </p>

          <!-- Last Name -->
          <label
            class="pt-4 block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="last">
            Last Name
          </label>
          <input
            v-model.trim="$v.formResponses.last_name.$model"
            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            type="text"
            placeholder="Doe"
            required
          >
          <p v-if="this.invalid">
            <span v-if="!$v.formResponses.last_name.required" class="text-red-500 text-xs italic mt-1 ml-1">Please fill out your last name.</span>
          </p>

          <!-- Company -->
          <label
            class="pt-4 block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="company">
            Company
          </label>
          <input
            v-model.trim="$v.formResponses.company.$model"
            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            type="text"
            placeholder="Acme Corp"
            required
          >
          <p v-if="this.invalid">
            <span v-if="!$v.formResponses.company.required" class="text-red-500 text-xs italic mt-1 ml-1">Please fill out your company name.</span>
          </p>

          <label
            class="pt-4 block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="email">
            Email
          </label>
          <input
            v-model.trim="$v.formResponses.email.$model"
            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            type="email"
            placeholder="jane.doe@acme.com"
            required
          >
          <p v-if="this.invalid">
            <span v-if="!$v.formResponses.email.required" class="text-red-500 text-xs italic mt-1 ml-1">Please fill out your email.</span>
            <span v-if="!$v.formResponses.email.email" class="text-red-500 text-xs italic mt-1 ml-1">Please fill out a valid email.</span>
          </p>

          <label
            class="pt-4 block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            for="password">
            Password
          </label>
          <input
            v-model.trim="$v.formResponses.password.$model"
            class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            type="password"
            placeholder="Password"
            required
          >
          <p v-if="this.invalid">
            <span v-if="!$v.formResponses.password.required" class="text-red-500 text-xs italic mt-1 ml-1">Please fill out your password.</span>
            <span v-if="!$v.formResponses.password.minLength" class="text-red-500 text-xs italic mt-1 ml-1">Please ensure your password is longer than 6 characters.</span>
          </p>

          <p class="text-red-500 text-xs italic">
            <span>{{$v.password}}</span>
          </p>
          <div class="flex flex-col content-center">
            <button
              @click.prevent="signUp()"
              class="self-center bg-indigo-500 hover:bg-indigo-700 mt-8 mb-6 justify-center text-white font-medium text-xl py-2 px-6 rounded-full"
            >
              Create my free account
            </button>
            <router-link
            class="self-center text-gray-600 text-sm"
            to="/login">
              Already have an account? <span class="text-indigo-600 underline">Sign in</span>
            </router-link>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>


<script>
  // import firebase from "firebase";
  import firebase from '@/utils/firebase'
  import { required, email, minLength } from 'vuelidate/lib/validators'

  export default {
    name: 'signup',
    data () {
      return {
        formResponses: {
          first_name: '',
          last_name: '',
          company: '',
          email: '',
          password: '',
        },
        invalid: false
      }
    },

    validations: {
      formResponses: {
        first_name: {
          required,
        },
        last_name: {
          required,
        },
        company: {
          required,
        },
        email: {
          required,
          email,
        },
        password: {
          required,
          minLength: minLength(6)
        }
      }

    },

    methods: {
      signUp(){
        this.invalid = this.$v.formResponses.$invalid;

        if(!this.invalid){
          // submit form
          this.createFirebaseAccount()
        }
      },

      createFirebaseAccount(){
        //this is where you send the responses
        firebase.auth()
        .createUserWithEmailAndPassword(this.formResponses.email, this.formResponses.password)
          .then(data => {
            // add a company
            const newCompany = firebase.database().ref('companies')
            .push({
              name: this.formResponses.company,
              created_at: firebase.database.ServerValue.TIMESTAMP
            })
            .catch(err => {
              console.log(err)
            });

            // add a user with the uid as the key
            // let usersRef = firebase.database().ref('users');
            var userKey = data.user.uid
            const userRef = firebase.database().ref('users')
            userRef.child(userKey).set({
              uid: data.user.uid,
              first_name: this.formResponses.first_name,
              last_name: this.formResponses.last_name,
              email: this.formResponses.email,
              company: this.formResponses.company,
              companyId: newCompany.key,
              created_at: firebase.database.ServerValue.TIMESTAMP
            })
            .catch(err => {
              console.log(err)
            });

            this.$router.replace({name: "Conversations"});
          })
          .catch(err => {
            console.log(err)
          });
      }
    }
  }
</script>

<style lang="css" scoped>
  @tailwind utilities;

</style>
